module.exports = __webpack_public_path__ + "img/month.be5030ca.webp";